import { UserIcon } from "assets/icons/User";
import { IOrderTypesVisible } from "types/Account/Account";

import { OrderType } from "../OrderType";
import { PatientInfoForm } from "../PatientInfoForm";
import { StepCard } from "../StepCard";
import { StepKey } from "../StepCard/helper";
import { useStepStatus } from "../StepCard/useStepStatus";

export function PatientStep({
  orderTypesVisible,
  isFetching,
  redo = false,
}: {
  orderTypesVisible?: IOrderTypesVisible;
  isFetching?: boolean;
  redo?: boolean;
}) {
  const status = useStepStatus(StepKey.PATIENT);

  return (
    <StepCard
      status={status}
      icon={<UserIcon width={24} height={24} />}
      title="Patient"
      description="Choose an order type and enter the patient's details"
    >
      <OrderType
        embedded
        orderTypesVisible={orderTypesVisible}
        isFetching={isFetching}
        redo={redo}
      />

      <PatientInfoForm embedded />
    </StepCard>
  );
}
